import { ORDER_STATUS } from "../../../components/components.constants";

export const buildPurchaseHistoryModalConfig = ({ actions, ctx, components, uiState }) => {
  const {
    patchOrders,
    refetchOrderItems,
    onInputsSave,
    setShowModal,
    setInputs,
    setShowInputs,
    setShowSuccessModal,
    setCheckedProducts,
    updateRecommendation,
    setIsPatchingOrderInParent,
    setShowCancelModalOrderRollback,
    setLocalOrderItems
  } = actions;

  const {
    ordersData,
    orderDetailsModalColumns,
    tableInfo,
    selectedOrderId,
    orderItemsToUse,
    orderInfo,
    storeId,
    t,
    userId
  } = ctx;

  const {
    showModal,
    showCancelModalOrderRollback,
    checkedProducts,
    inputs,
    showInputs,
    isUpdating,
    isPatchingOrder,
    isPatchingOrderInParent,
    renderModal,
    isLoadingOrderItems,
  } = uiState;

  return {
    modalState: {
      showModal,
      showCancelModalOrderRollback,
      isPatchingOrderInParent,
    },
    components: {
      showModal: components.ModalToDisplayOrder,
      showCancelModalOrderRollback: components.ModalToCancelOrder,
      isPatchingOrderInParent: components.OrderCancellationSuccessModal,
    },
    propsMap: {
      showModal: {
        actions: {
          patchOrders,
          refetchOrderItems,
          onInputsSave,
          onClose: () => setShowModal(false),
          setInputs,
          setShowInputs,
          setShowSuccessModal,
          setCheckedProducts,
          updateRecommendation,
          setLocalOrderItems
        },
        ctx: {
          orders: ordersData || [],
          columns: orderDetailsModalColumns,
          tableInfo,
          orderId: selectedOrderId,
          orderItemsToUse,
          userId,
          orderInfo,
        },
        uiState: {
          checkedProducts,
          inputs,
          showInputs,
          saveLoading: isUpdating,
          isPatchingOrder,
          isLoadingItems: isLoadingOrderItems,
          renderModal,
        },
      },
      showCancelModalOrderRollback: {
        t,
        isPurchaseHistoryPage: true,
        setShowInputs,
        selectedOrderId,
        setInputs,
        patchOrders: () => {
          setIsPatchingOrderInParent(true);
          patchOrders.mutate(
            {
              orderId: selectedOrderId,
              storeId,
              orderStatus: ORDER_STATUS.CANCELED,
              userId
            },
            {
              onSuccess: () => {
                setIsPatchingOrderInParent(false);
                setShowCancelModalOrderRollback(false);
                setShowSuccessModal(true);
              },
              onError: (err) => {
                setIsPatchingOrderInParent(false);
                console.error("Erro ao atualizar pedido:", err);
              },
            }
          );
        },
        setShowCancelModalOrderRollback,
      },
      isPatchingOrderInParent: {
        ctx: {
          count: 1,
          label: {
            primaryMessage: t("cancelling"),
            dynamicMessagesArr: [t("cancellingOrder"), ""],
          },
        },
        uiState: {
          isOpen: isPatchingOrderInParent,
        },
      },
    },
  };
};